/**
 * Application-level constants derived from global configuration.
 * These are runtime values injected by the backend.
 */

export const DEFAULT_LANGUAGE = window.SCHA.config.fallbackLanguage || "en";
export const CURRENT_LANGUAGE = window.SCHA.config.language || DEFAULT_LANGUAGE;
export const AVAILABLE_LANGUAGES = window.SCHA.config.availableLanguages;

export const CURRENCY_ISO = window.SCHA.config.currencyIso || "GBP";

export const SALES_REP_PHONE_NO = window.SCHA.config.salesRepPhone;

export const HAS_END_CUSTOMER = window.SCHA.config.hasEndCustomer;

export const GOOGLE_GEOAPI_KEY = window.SCHA.config.googleGeocodingKey;

// depends on how many price scales we will have from backend
// Subtracting 1 so it's 1-based for configurator while 0-based for code
export const MAX_VISIBLE_PRICE_SCALE = (window.SCHA.config.maxVisiblePriceScale || 0) - 1;

export const CAPTCHA_SITE_KEY = window.SCHA.config.captchaSiteKey;
export const CAPTCHA_ENABLED = window.SCHA.config.captchaEnabled;

// If there are more products in cart than this amount
export const CART_PNA_THRESHOLD = window.SCHA.config.maxCartSizeWithPnaCall;

// Number of days from today in which a delivery date can be selected
export const DELIVERY_DATE_OFFSET = window.SCHA.offsetRDD;

export const BEARINGX_API_URL = window.SCHA.bearingXUrl;

// Batching configuration
export const BATCHING_INTERVAL = window.SCHA.batching.interval;
export const BATCHING_SIZE_RESET_TIME = window.SCHA.batching.sizeResetTime;
export const BATCHING_PRICE_ENABLED = window.SCHA.batching.pna.pEnabled;
export const BATCHING_AVAILABILITY_ENABLED = window.SCHA.batching.pna.aEnabled;
export const BATCHING_PNA_BATCHES = window.SCHA.batching.pna.batches;
export const BATCHING_UPDATE_LINEITEM_ENABLED = window.SCHA.batching.lineItemUpdate.enabled;
export const BATCHING_UPDATE_LINEITEM_BATCHES = window.SCHA.batching.lineItemUpdate.batches;

// CC
export const CC_MIN_JS_FILE_URL = window.SCHA.ccMinJSFileURL;

// Site detection
const siteCode = window.SCHA.config.siteUid.slice(-2).toLowerCase();
export const REMOVE_SALES_PARTNER_FINDER = siteCode === "cn";
export const IS_US_SITE = siteCode === "us";
